<template>
  <v-card-modal>
    <ModalHeader :title="title" />
    <div class="modal-card__body px-4 px-sm-6 pb-4 pb-sm-6 pt-0">
      <v-img :alt="alt" class="serial-number-preview" :src="src" contain />
    </div>
    <div class="modal-card__footer">
      <v-btn @click="$emit('closeModal', true)">
        {{ $t('COMMON.BUTTON.CLOSE') }}
      </v-btn>
    </div>
  </v-card-modal>
</template>

<script>
import ModalHeader from '@/components/ui/ModalHeader.vue'

export default {
  name: 'RepairFileSerialNumberImageModal',
  components: { ModalHeader },
  props: {
    alt: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  emits: ['closeModal']
}
</script>

<style scoped>
.serial-number-preview {
  background: var(--soft-surface-color);
  max-height: 70vh;
  min-height: 240px;
}
</style>
